import { render, staticRenderFns } from "./CDRStatisticsSearch.vue?vue&type=template&id=cb6b428e"
import script from "./CDRStatisticsSearch.vue?vue&type=script&lang=ts"
export * from "./CDRStatisticsSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports